import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  ADD_POST,
  BOOKMARKS,
  CONTACT_US,
  ADD_CARD,
  HELP_SUPPORT,
  LIKEDPOSTS,
  LISTS,
  MESSAGES,
  NOTIFICATIONS,
  PROFILE,
  ROOT,
  SETTINGS_ACCOUNT,
  SETTINGS_FINANCIAL,
  SETTINGS_PROFILE,
  SUBSCRIBERS,
  MENUSETTINGS,
  PAYMENTS,
  SUBSCRIPTIONS,
  SAVED_POSTS,
  TERMS_PRIVACY,
  SEND_MESSAGE,
  QUESTION_SUPPORT,
  SEARCH_SUPPORT,
  USER_PROFILE,
  CHANNELS,
  MEMBERS,
  ADD_BANK,
  BANK_ACCOUNT
} from '../../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';
import {
  BellIcon,
  HomeIcon,
  MailIcon,
  PlusCircleIcon,
  ProfileIcon,
  HomeIconActive,
  PlusCircleIconActive,
  BellIconActive,
  MailIconActive,
  ProfileIconActive,
} from '../Icons';
import { useTranslation } from 'react-i18next';
import { selectChatUnreadCount } from '../../reducers/notifications/notifications.selectors';
import { setChatUnreadCountActionCreator } from '../../reducers/notifications/notifications.actionCreators';
import { selectAuthUser, selectNotificationsCount } from '../../reducers/auth/auth.selectors';
import Header from '../generic-components/Header';
import BurgerMenu from '../layout/BurgerMenu';
import { getNotificationsCount } from 'reducers/auth/auth.actions';

const MainLayout = ({ header,children }) => {
  const verification_status = "verified"
  const match = useRouteMatch()
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const notificationsCount = useSelector(selectNotificationsCount);
  const [activeItem, setActiveItem] = useState({ index: null, title: null });
  const [showHeader, setShowHeader] = useState(true);
  const [sidebar, setSidebar] = useState(false);
  const isHebrew = localStorage.getItem('current_language') === "he";

  const menuItems = [
    {
      routes: [ROOT],
      titles: [t('feed')],
    },
    {
      routes: [ADD_POST],
      titles: [t('')],
    },
    {
      routes: [NOTIFICATIONS],
      titles: [t('notifications')],
    },
    {
      routes: [PROFILE, SETTINGS_FINANCIAL, SETTINGS_ACCOUNT, SETTINGS_PROFILE, HELP_SUPPORT, QUESTION_SUPPORT, SEARCH_SUPPORT],
      titles: [t('profile'), t('financial'), t('account'), t('edit profile'), t('help & support'), t('help & support'), t('Search questions')],
      
    },
    {
      routes: [MESSAGES],
      titles: [t('messages')],
    },
    {
      routes: [BOOKMARKS, LISTS, LIKEDPOSTS, SUBSCRIBERS, SUBSCRIPTIONS, CONTACT_US, SAVED_POSTS, TERMS_PRIVACY, MENUSETTINGS,ADD_CARD, PAYMENTS, CHANNELS, MEMBERS, ADD_BANK, BANK_ACCOUNT],
      titles: [
        t('bookmarks'),
        t('lists'),
        t('Liked Posts'),
        t('Subscribers'),
        t('Subscriptions'),
        t('Contact us'),
        t('Saved posts'),
        t('Terms & Privacy'),
        t('Settings'),
        t('Payments'),
        t('Add card'),
      
        t('channels'),
        t('members'),
       t('Add bank')
      ],
    },
  ];

  useEffect(() => {
    if (location.pathname) {
      setActiveItem({ index: null, title: null });
      const path = location.pathname;
      for (let i = 0; i < menuItems.length; i++) {
        let index = menuItems[i].routes.indexOf(path);
        if (index > -1) {
          setActiveItem({ index: i, title: menuItems[i].titles[index] });
          break;
        }
      }
      if (path === MESSAGES) {
        dispatch(setChatUnreadCountActionCreator(0));
      }
    }
    setShowHeader(USER_PROFILE === match.path);
    const script = document.createElement('script');
    process?.env.REACT_APP_BLUESNAP_ENV  === 'sandbox' ? 
                                            script.src = "https://sandbox.bluesnap.com/web-sdk/4/bluesnap.js" : 
                                            script.src = "https://ws.bluesnap.com/web-sdk/4/bluesnap.js"   
     script.async = true;

    document.body.appendChild(script);
    return () => {
        document.body.removeChild(script);
    }
  }, [location, t]);

  const callback = useCallback((bar) => {
    setSidebar(bar);
  }, []);
  
  useEffect(() => {
    dispatch(getNotificationsCount());
    if(location.pathname !== '/notifications') {
      const timer = setInterval(() => dispatch(getNotificationsCount()), 5000);
      return () => clearInterval(timer);
    }
  }, [location.pathname]);

  return (
    <div className={`main-layout-wrapper ${isHebrew ? "hebrew" : ''}`}>

      {!!header && !showHeader && !(SETTINGS_PROFILE ===match.path)  && !(ADD_CARD===match.path) && <Header currentLocation={match.path} showHeader={showHeader} activeItem={activeItem} user={user} />}
    <div className={!!sidebar ? "visible-menu-toggle main-layout  container-fluid d-flex p-0 position-relative" : 'main-layout  container-fluid d-flex p-0 position-relative'}>
      <div className={`side-menu `}>
      <Link to={ROOT}>
        <div className= "avatar-button">
        {activeItem?.index === 0 ? <HomeIconActive /> : <HomeIcon />}
       
      </div> 
      </Link>

        <Link to={
          {
            pathname: user?.verification_status === "verified" ? ADD_POST : SETTINGS_PROFILE,
            state: {shouldUploadAvatar: verification_status === "verified"}
           }
          }>
          <div className= "avatar-button">
            {activeItem?.index === 1 ? <PlusCircleIconActive /> : <PlusCircleIcon />}
           </div> 
          </Link>
        <div style={{ position: 'relative' }}>
          <Link to={NOTIFICATIONS}>
            <div className= "avatar-button">
              {activeItem?.index === 2 ? <BellIconActive /> : <BellIcon />}
            </div>
          </Link>
          {!!notificationsCount && (
            <div 
              style={{ width: notificationsCount > 9 ? '29px' : '20px', right: notificationsCount > 9 ? '-8px' : '2px' }} 
              className="notification-count"
            >
              {notificationsCount > 9 ? '9+' : notificationsCount}
            </div>
          )}
        </div>
        <BurgerMenu parentCallback={callback} isHebrew={isHebrew}/>


      </div>

      <div className={`main-container w-100 offset-side-menu pt-0`}>{children}</div>
    </div>
    </div>
  );
};

export default MainLayout;
